import { authHeaders } from '../../../core/api/authHeaders';

const PROXY_BASE = (import.meta.env.VITE_PROXY_URL || (import.meta.env.DEV ? 'http://localhost:3001' : '')).replace(/\/$/, '');

/**
 * Search one conversation's FULL history on the server (server/chat/chatSearch.js).
 *
 * The browser only holds the newest messages now, so a local filter would silently miss
 * everything older; the server also re-checks that the caller is a member of the chat.
 *
 * @returns {Promise<{hits: object[], total: number, truncated: boolean}>}
 * @throws {Error} with a message fit to show the user
 */
export async function searchConversation(chatId, q, { signal } = {}) {
    const url = `${PROXY_BASE}/api/chat/search?chatId=${encodeURIComponent(chatId)}&q=${encodeURIComponent(q)}`;
    let res;
    try {
        res = await fetch(url, { headers: await authHeaders(), signal });
    } catch (e) {
        if (e?.name === 'AbortError') throw e;
        throw new Error('Search is unavailable — check your connection.');
    }
    let body = null;
    try { body = await res.json(); } catch { /* non-JSON error page */ }
    if (!res.ok) throw new Error(body?.error || `Search failed (${res.status}).`);
    return { hits: body?.hits || [], total: body?.total || 0, truncated: !!body?.truncated };
}
